import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
    selector: 'app-endereco-form',
    templateUrl: './endereco-form.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, NgxMaskDirective]
})
export class EnderecoFormComponent {
  @Input() formulario: UntypedFormGroup;
  @Input() consultaCep: any;
  @Input() mensagemErro: string;
  @Input() mostrarResponsaveis = true;

  /** True enquanto a requisição de CEP está em andamento */
  get consultaCepLoading(): boolean {
    return this.consultaCep === null;
  }

  /** True quando a consulta de CEP retornou erro */
  get consultaCepErro(): boolean {
    return this.consultaCep === false;
  }

  /**
   * True quando a consulta de CEP foi bem-sucedida
   * (objeto preenchido, não null, não false, não undefined)
   */
  get consultaCepSucesso(): boolean {
    return this.consultaCep !== null && this.consultaCep !== undefined && this.consultaCep !== false;
  }

  somenteNumeros(e: any) {
    const charCode = e.charCode ?? e.keyCode;
    if (charCode != 8 && charCode != 9) {
      if ((charCode < 48 || charCode > 57) || (e.target.value.length >= 10)) return false;
    }
  }
}
